import { Component, inject, model } from '@angular/core';
import { PageTitleComponent } from '../../../../components/page-title/page-title.component';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzCheckboxModule } from 'ng-zorro-antd/checkbox';
import { FormsModule } from '@angular/forms';
import { HomeApiClientService, NIASBizWebModelsTermsOfUseModel } from '../../../../api/v1';
import { DocumentActionService } from '../../../../services/document-action.service';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-term-of-use',
  templateUrl: 'terms-of-use.page.html',
  imports: [PageTitleComponent, NzButtonModule, NzCheckboxModule, FormsModule, TranslatePipe] 
})
export class TermsOfUsePage {
  private homeApiClientService: HomeApiClientService = inject(HomeApiClientService);
  private documentActionService: DocumentActionService = inject(DocumentActionService); 
  
  public isAgree = model<boolean>(true);

  public onOpenTermsOfUse() {
    this.homeApiClientService.homeApiTermsOfUse().subscribe((res: NIASBizWebModelsTermsOfUseModel) => {
      this.documentActionService.openBase64Document(res.TermsPdf!, 'application/pdf');
    })
  }  
}